import { overviewCards } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function OverviewSection() {
  return (
    <section id="overview" className="w-full bg-background-50 px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          eyebrow="本站导览"
          title="这个站点提供什么"
          desc="我们用“先分类、再挑选”的方式整理岳母题材的同人创作。四大板块各自解决一个找内容时最常遇到的问题，让你不必在海量条目里反复试错。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {overviewCards.map((card, idx) => (
            <article
              key={card.title}
              className="group rounded-lg bg-background-100 border border-background-200/70 p-5 md:p-6 flex flex-col"
            >
              <div className="flex items-center justify-between">
                <span className="w-12 h-12 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center">
                  <i className={`${card.icon} text-2xl`}></i>
                </span>
                <span className="font-heading text-2xl font-bold text-background-300">
                  0{idx + 1}
                </span>
              </div>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">
                {card.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed flex-1">
                {card.desc}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}